import * as React from 'react';
import { Flex, Text } from "./..";
import { PageSizeSelector } from './PageSizeSelector';
import { Paginator } from './Paginator';
export var Pagination = function (_a) {
    var onChange = _a.onChange, _b = _a.pageSizes, pageSizes = _b === void 0 ? [10, 20, 50] : _b, _c = _a.adjacentPages, adjacentPages = _c === void 0 ? 2 : _c, _d = _a.total, total = _d === void 0 ? 0 : _d, _e = _a.pageSize, pageSize = _e === void 0 ? 20 : _e, _f = _a.page, page = _f === void 0 ? 1 : _f, id = _a.id;
    var from = total === 0 ? 0 : (page - 1) * pageSize + 1;
    var to = Math.min(total, page * pageSize);
    var handleChange = function (data) {
        if (onChange) {
            onChange({
                pageSize: (data === null || data === void 0 ? void 0 : data.pageSize) || pageSize,
                page: (data === null || data === void 0 ? void 0 : data.page) || 1
            });
        }
    };
    if (!total) {
        return null;
    }
    return (React.createElement(Flex, { lss: {
            justifyContent: 'space-between',
            alignItems: 'center'
        } },
        React.createElement(PageSizeSelector, { id: id, onChange: handleChange, pageSize: pageSize, pageSizes: pageSizes }),
        React.createElement(Flex, { as: "span", lss: {
                flex: '1 1 auto'
            } }),
        React.createElement(Flex, { lss: {
                mx: 'md'
            } },
            React.createElement(Paginator, { id: id, onChange: handleChange, adjacentPages: adjacentPages, page: page, pageSize: pageSize, total: total })),
        React.createElement(Text, { as: "p", lss: {
                textScale: 'caption'
            } }, from + "-" + to + " of " + total)));
};
//# sourceMappingURL=Pagination.js.map